import QrAllPrintContent from '../../../../LogisticsManagement/InBound/QrAllPrintContent'
import { LoadingButton } from "@mui/lab";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
// import { transformDataWithFiles } from '../../../../../../pages/appointment-details/common-pre-screen/common';
// import { fetchDetailsInBound } from '../../../../../slices/inbound';
import NoDataCard from '../../../../../../components/no-data-card';
import SkeletonLoader from '../../../../../../utilites/SkeltonLoader';
import { Box } from '@mui/material';
import { selectAllInitialSteps,selectFollowCycle } from '../../../../../slices/common';
import { INITIAL_VALUES_1, INITIAL_VALUES_2, STATUS_COMPLETED, STEP_SLUGS } from '../../../../LogisticsManagement/OutBound/Form/common';
import { fetchPreFilledData, fetchOutbondDetails } from '../../../../../slices/outbound';
import { dateFormater } from '../../../../../utils/common/utils';
// import { formatDateMoment } from '../../../../../../utils/utils';
import {
    confirmationOptions
} from "../../../../../../pages/appointment-details/common-in-bound/common";
import { PrimaryRefractoryOptions } from "../../../../../../pages/appointment-details/common-pre-screen/common";
import { selectDropDownDataMaster, fetchManufecturingButtonDropDown } from "../../../../../slices/customMaster"


const DownlaodOutboundForm = ({patientData}) => {
  const [allPrintData, setAllPrintData] = useState({});
   const currentCycle = useSelector(selectFollowCycle);
    const equipmentOptions = useSelector(selectDropDownDataMaster('equipment'))

  // const [inBoundForm, setInBoundForm] = useState({});
//   const [isLoading, setIsLoading] = useState(false)
const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch()
  const printTimeoutAllRef = useRef(null);
  const printContentAllRef = useRef(null);
  // const LoginData = useSelector((state) => state.loginData);
     const { role_id,role_slug } = useSelector((state) => state.loginData);
  // const now = new Date();
  // const timeString = now.toTimeString().slice(0, 5); // "HH:MM"
 const allInitialSteps = useSelector(selectAllInitialSteps);
//   console.log("current", currentCycle,'patientData', patientData)
    // Memoized step status checks
      const { checkOutbondPart1Enable, checkOutbondPart2Enable, qaOutbondForm } = useMemo(() => {
          const qualityControlStep = allInitialSteps?.find(
              step => step.slug === STEP_SLUGS.QUALITY_CONTROL
          );
  
          const productShippedStatus = allInitialSteps?.find(
              step => step.slug === STEP_SLUGS.PRODUCT_SHIPPED
          );
         const productShippedReceieved = allInitialSteps?.find(
              step => step.slug === STEP_SLUGS.PRODUCT_RECEIVED
          );
          const productShipped = allInitialSteps?.find(
              step => step.slug === STEP_SLUGS.INFUSION
          );
          
          return {
              checkOutbondPart1Enable: qualityControlStep?.status === STATUS_COMPLETED,
              // part1buttonDisable: productShippedStatus?.status >= STATUS_IN_PROGRESS,
              // part2buttonDisable: productInfusionStatus?.status != STATUS_SUBMITED && productInfusionStatus?.status != STATUS_PENDING,
              // productSubmited: productInfusionStatus?.status == STATUS_SUBMITED,
              checkOutbondPart2Enable: productShippedStatus?.status === STATUS_COMPLETED && (role_id == 5 ||  role_slug === "project-manager"),
              checkOutbondSubmitEnable: productShippedReceieved?.status === STATUS_COMPLETED && (role_id == 5 ||  role_slug === "project-manager"),
              qaOutbondForm: productShipped?.status === STATUS_COMPLETED && role_slug == 'quality-associate'
          };
      }, [allInitialSteps]);

       useEffect(() => {
        dispatch(fetchManufecturingButtonDropDown('equipment'))
    },[])

          const outBoundFormValuesPart1 = useMemo(() => [
              { section:"Patient & Collection Details" },
              {
                  label: "Hospital Name",
                  type: "text",
                  name: "hospital_name",
                  placeholder: "Enter Hospital Name",
                  disabled: true,
                  col: 2,
              },
              {
                  label: "Hospital Patient ID",
                  type: "text",
                  name: "hospital_patient_id",
                  placeholder: "Enter Hospital Patient ID",
                  required: true,
                  disabled: true,
                  noQuery: true,
                  col: 4,
                  isFirstPartField: true,
              },
              {
                  label: "ImmunoACT Patient ID",
                  type: "text",
                  name: "patient_id",
                  placeholder: "Enter ImmunoACT Patient ID",
                  disabled: true,
                  noQuery: true,
                  col: 4,
                  isFirstPartField: true,
              },
              {
                  label: "Patient Full Name",
                  type: "text",
                  name: "full_name",
                  placeholder: "Enter Patient Full Name",
                  disabled: true,
                  noQuery: true,
                  col: 3,
                  isFirstPartField: true,
              },
              {
                  label: "Patient Initials",
                  type: "text",
                  name: "sub_initials",
                  placeholder: "Enter Patient Initials",
                  noQuery: true,
                  disabled: true,
                  col: 3,
                  isFirstPartField: true,
              },
              {
                  label: "Date of Birth",
                  type: "text",
                  name: "dob",
                  placeholder: "Enter Date of Birth",
                  disabled: true,
                  noQuery: true,
                  col: 3,
                  isFirstPartField: true,
              },
              {
                  label: "Disease Indication",
                  type: "text",
                  name: "disease_name",
                  placeholder: "Enter Disease Indication",
                  disabled: true,
                  noQuery: true,
                  col: 3,
                  isFirstPartField: true,
              },
              {
                  label: "Patient Weight(Kg)",
                  type: "number",
                  disabled: true,
                  name: "patient_weight",
                  placeholder: "Enter Patient Weight (Kg)",
                  required: true,
                  col: 3,
              },
              {
                  label: "Patient Weight Submitted",
                  type: "text",
                  disabled: true,
                  name: "created_at",
                  required: true,
                  col: 3,
              },
              {
                  label: "Batch Number",
                  type: "text",
                  disabled: true,
                  name: "batch_no",
                  placeholder: "Enter Batch Number",
                  required: true,
                  col: 3,
              },
              { section: "Time & Temperature at finish product dispatch" },
              {
                  label: "Manufacturing date",
                  type: "text",
                  name: "manufacturing_date",
                  disabled: true,
                  placeholder: "Enter Manufacturing date",
                  required: true,
                  col: 3,
              },
              {
                  label: "Expiry Date",
                  type: "text",
                  name: "expiry_date",
                  disabled: true,
                  placeholder: "Enter Expiry Date",
                  required: true,
                  col: 3,
              },
              {
                  label: "Quantity (Number of Bags)",
                  type: "number",
                  disabled: true,
                  name: "number_of_bags",
                  placeholder: "Enter Quantity (number of bags)",
                  required: true,
                  col: 3,
              },
              {
                  label: "Volume(ml)",
                  type: "text",
                  disabled: true,
                  name: "used_blood",
                  placeholder: "Volume used",
                  required: false,
                  col: 2,
              },
              {
                  label: "COA",
                  type: "radio",
                  name: "has_coa_form",
                  options: PrimaryRefractoryOptions,
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              {
                  label: "Mode of Dispatch",
                  type: "text",
                  name: "mode_of_dispatch",
                  placeholder: "Select Mode of Dispatch",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              {
                  label: "Serial No",
                  type: "text",
                  disabled: true,
                  name: "data_logger_serial_no",
                  placeholder: "Enter Data Logger Serial No",
                  col: 2,
                  isFirstPartField: true,
              },
              {
                  label: "Equipment ID",
                  disabled: true,
                  type: "select",
                  name: "equipment_id",
                  placeholder: "Select Equipment ID",
                  options: equipmentOptions,
                  col: 2,
                  isFirstPartField: true,
              },
              {
                  type: "date",
                  name: "date_of_dispatch_of_finished_product",
                  placeholder: "Select Date of Dispatch",
                  disabled: true,
                  required: true,
                  min: new Date(),
                  inputClassName: "!py-[13px] !px-[13px]",
                  col: 1,
                  isFirstPartField: true,
              },
              {
                  label: "Temperature at Dispatch (°C)",
                  type: "number",
                  name: "dispatch_temperature",
                  placeholder: "Enter Temperature at Dispatch (°C)",
                  isTempratureField: true,
                  min: -80,
                  required: true,
                  col: 2,
                  isFirstPartField: true,
              },
              {
                  label: "Time of Dispatch",
                  type: "time",
                  name: "dispatch_time",
                  placeholder: "Select Time of Dispatch",
                  required: true,
                  col: 2,
                  isFirstPartField: true,
              },
           
          ], []);
      
         const outBoundFormValuesPart2 = useMemo(() => [
              { section: "Dispatched By" },
              {
                  type: "text",
                  name: "dispatched_by_sign",
                  placeholder: "Select Time of Dispatch",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              {
                  type: "text",
                  name: "dispatched_by_date",
                  placeholder: "Select Time of Dispatch",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              { section: "Verified by" },
              {
                  type: "text",
                  name: "verified_by",
                  placeholder: "Select Time of Dispatch",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              {
                  type: "text",
                  name: "verified_by_date",
                  placeholder: "Select Time of Dispatch",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              { section: "Handover To" },
              {
                  type: "text",
                  name: "handover_to_sign",
                  placeholder: "Select Time of Dispatch",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              {
                  type: "text",
                  name: "handover_to_date",
                  placeholder: "Select Time of Dispatch",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              { section:"Receipt & Verification (IA Warehouse/Logistics/QA)" },
              {
                  name: "patient_details_verified",
                  label: "Patient details verified",
                  type: "radio",
                  options: confirmationOptions,
                  required: true,
                  col: 2,
              },
              {
                  name: "receipt_date",
                  label: "Date of receipt",
                  type: "date",
                  required: true,
                  placeholder: "Select Date of Receipt",
                  min: new Date().toISOString().split("T")[0],
                  inputClassName: "!py-[13px] !px-[13px]",
                  col: 1,
              },
              { section: "Physical integrity of transport box and product to be checked" },
              {
                  name: "leakage_observed",
                  label: "Leakage",
                  type: "radio",
                  options: confirmationOptions,
                  required: true,
                  col: 2,
              },
              {
                  name: "leakage_observed_comment",
                  type: "textarea",
                  label: "Leakage 's Comment",
                  depend: "leakage_observed",
                  dependValue: "true",
                  required: true,
                  col: 2,
              },
              {
                  name: "broken_seal",
                  label: "Broken Seal",
                  type: "radio",
                  required: true,
                  options: confirmationOptions,
                  col: 2,
              },
              {
                  name: "broken_seal_comment",
                  type: "textarea",
                  label: "Broken Seal 's Comment",
                  depend: "broken_seal",
                  dependValue: "true",
                  required: true,
                  col: 2,
              },
              {
                  name: "broken_transport_box",
                  label: "Broken Transport Box",
                  type: "radio",
                  required: true,
                  options: confirmationOptions,
                  col: 2,
              },
               {
                  name: "broken_transport_box_comment",
                  type: "textarea",
                  label: "Broken Transport Box 's Comment",
                  depend: "broken_transport_box",
                  dependValue: "true",
                  required: true,
                  col: 2,
              },
              { section: "Time & Temperature at receipt of Finished Product" },
               {
                      name: "temperature_excursion",
                      label: "Temperature Excursion",
                      type: "text",
                      required: true,
                      options: confirmationOptions,
                      col: 2,
                      isResolve: ["quality-check"],
               },
              {
                  name: "temperature_excursion_comment",
                  type: "textarea",
                  label: "Temperature Excursion 's Comment",
                  depend: "temperature_excursion",
                  dependValue: "true",
                  required: true,
                  col: 2,
              },
              {
                  name: "receipt_temperature",
                  label: "Excursion Temperature (°C)",
                  type: "number",
                  depend: "temperature_excursion",
                  dependValue: "true",
                  required: true,
                  placeholder: "Enter Excursion Temperature",
                  isTempratureField: true,
                  min: -80,
                  max: 30,
                  col: 2,
              },
                   {
                  name: "excursion_duration",
                  label: "Excursion Duration (HH:MM)",
                  type: "text",
                  required: true,
                  placeholder: "e.g. 48:30",
                  depend: "temperature_excursion",
                  dependValue: "true",
                  col: 2,
              },
              {
                  name: "receipt_time",
                  label: "Excursion Time",
                  type: "time",
                  depend: "temperature_excursion",
                  dependValue: "true",
                  required: true,
                  placeholder: "Select Excursion Time",
                  col: 2,
              },
              { section: "Quantity Received (Number of Bags)" },
              {
                  name: "quantity_received",
                  type: "number",
                  placeholder: "Enter Quantity Received",
                  required: true,
                  col: 1,
              },
              { section: "Received By" },
              {
                  type: "text",
                  name: "receipt_received_by_name",
                  placeholder: "Enter the receiver name",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              {
                  type: "text",
                  name: "receipt_received_by_date",
                  placeholder: "Enter the receiver sign & date",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              { section: "Receipt Verified By" },
              {
                  type: "text",
                  name: "receipt_verified_by_name",
                  placeholder: "Enter the verifier name",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
              {
                  type: "text",
                  name: "receipt_verified_by_date",
                  placeholder: "Enter the verifier sign & date",
                  required: true,
                  disabled: true,
                  col: 2,
                  isFirstPartField: true,
              },
          ], []);
      

  


    const outBoundFormValuesPart3 = useMemo(() => [
        {section: 'QA Acknowledgment'},
        {
            label: "Remarks",
            type: "textarea",
            name: "comment",
            placeholder: "Enter comment",
            // disabled: !commentStatus,
            noQuery:true,
            required: true,
            col: 1,
        }
    ], [])

  

    // Combined form fields based on enabled parts
    const fieldSet = useMemo(() => {
        const fields = [];

        if (checkOutbondPart1Enable) {
            fields.push(...outBoundFormValuesPart1);
        }

        if (checkOutbondPart2Enable) {
            if (!checkOutbondPart1Enable) {
                fields.push(...outBoundFormValuesPart1);
            }
            fields.push(...outBoundFormValuesPart2);
        }
        if(qaOutbondForm){
          fields.push(...outBoundFormValuesPart3)
        }
        return fields;
    }, [checkOutbondPart1Enable, checkOutbondPart2Enable, outBoundFormValuesPart1, outBoundFormValuesPart2, qaOutbondForm]);
  const reactToPrintFnAll = useReactToPrint({
    content: () => printContentAllRef.current,
  });

// const values = useMemo(() => ({}), []);

//  const handleFullPrint = useCallback((fields, values) => {
//   setAllPrintData({ fields, values, state, title: "In-Bound Form" });

//   printTimeoutAllRef.current = setTimeout(() => {
//     reactToPrintFnAll();
//     printTimeoutAllRef.current = null;
//   }, 100);
// }, [reactToPrintFnAll, state]);
  const handleFullPrint = useCallback(() => {

  printTimeoutAllRef.current = setTimeout(() => {
    reactToPrintFnAll();
    printTimeoutAllRef.current = null;
  }, 100);
}, [reactToPrintFnAll]);


//   const fetchFormDetails = (fields, values) => {
//     // Prepare print data for preview only. Do not trigger the print dialog automatically.
//     setAllPrintData({ fields, values, state, title: "Out-Bound Form" })
//   }

  // let values = { ...partAInitialValues, ...partDInitialValues, ...partBInitialValues, ...partCInitialValues }

     const [outboundInitialValues, setOutboundInitialValues] = useState(() => {
          if (checkOutbondPart1Enable && checkOutbondPart2Enable) {
              return { ...INITIAL_VALUES_1, ...INITIAL_VALUES_2 };
          } else if (checkOutbondPart1Enable) {
              return INITIAL_VALUES_1;
          } else if (checkOutbondPart2Enable) {
              return INITIAL_VALUES_2;
          }
          return {}; // default empty object if neither is enabled
      });
  
      // Optimized data fetching functions
      const getOutboundFilledData = useCallback(async () => {
          if(!patientData.id && !currentCycle?.product_manufacturing_id && !currentCycle?.feasibility_assessments_id) return;
          const data = {
              product_manufacturing_id: currentCycle?.product_manufacturing_id,
              feasibility_assesment_id: currentCycle?.feasibility_assessments_id,
              patient_id:patientData.patient_information?.id
            }
            try {
              setIsLoading(true);
              const res = await dispatch(fetchPreFilledData(data)).unwrap();
              if (res.status === 200) {
                  setOutboundInitialValues(prevValues => ({
                      ...prevValues,
                      ...res.data,
                      batch_no: currentCycle?.batch_no,
                      full_name: `${res.data?.first_name} ${res.data?.last_name}`,
                      dob: res.data?.dob ? dateFormater(res.data?.dob) : "",
                      date_of_dispatch_of_finished_product: res.data?.date_of_dispatch_of_finished_product
                          ? dateFormater(res.data?.date_of_dispatch_of_finished_product) : "",
                      manufacturing_date: res.data?.manufacturing_date
                          ? dateFormater(res.data?.manufacturing_date) : "",
                      expiry_date: res.data?.expiry_date
                          ? dateFormater(res.data?.expiry_date) : "",
                      verified_by_date: res.data?.verified_by_date
                          ? dateFormater(res.data?.verified_by_date) : "",
                      handover_to_date: res.data?.handover_to_date
                          ? dateFormater(res.data?.handover_to_date) : "",
                      volume_in_each_bag: res.data?.volume_in_each_bag
                          ? JSON.parse(res.data?.volume_in_each_bag) : [],
                      used_blood: '100',
                       created_at: res.data?.created_at
                          ? dateFormater(res.data?.created_at) : "",
                          dispatched_by_date:res.data?.dispatched_by_date
                          ? (res.data?.dispatched_by_date) : "",
                  }
                ));
                
              }
             
          } catch (error) {
            setIsLoading(false);
              console.error("Error fetching prefilled data:", error);
          }
          finally{
            setIsLoading(false);
          }
      }, [dispatch, patientData.id,currentCycle]);
      const getOutbondFormDetails = useCallback(async () => {
          if (!currentCycle?.outbound_form_id) return;
          setIsLoading(true);
          try {
              const res = await dispatch(fetchOutbondDetails(currentCycle?.outbound_form_id)).unwrap();
  
              if (res.status === 200) {
                  setOutboundInitialValues(prevValues => ({
                      ...prevValues,
                      ...res.data,
                   status: currentCycle?.outbound_form_id ? res.data?.status : 0,
                      receipt_date: res.data?.receipt_date
                          ? dateFormater(res.data?.receipt_date) : "",
                      receipt_received_by_date: res.data?.receipt_received_by_date
                          ? dateFormater(res.data?.receipt_received_by_date) : "",
                      receipt_verified_by_date: res.data?.receipt_verified_by_date
                          ? dateFormater(res.data?.receipt_verified_by_date) : "",
                      receipt_received_by_name: res.data?.receipt_received_by_name || "",
                      receipt_time: res.data?.receipt_time || "",
                      receipt_temperature: res.data?.receipt_temperature || "",
                      excursion_duration: res.data?.excursion_duration || "",
                      temperature_excursion: res.data?.temperature_excursion==false? 'No':'Yes' || '',
                      temperature_excursion_comment: res.data?.temperature_excursion_comment || "",
                      quantity_received: res.data?.quantity_received || "",
                      comment : res.data?.qa_verified_comment || ""
                  }));
              }
          } catch (error) {
            setIsLoading(false);
              console.error("Error fetching outbound form details:", error);
          }
          finally{
            setIsLoading(false);
          }
      }, [dispatch, currentCycle?.outbound_form_id]);
  
   
        //   const { disabledAllItem } = useMemo(() => {
        //   const infusionDateFilledStatus = allInitialSteps?.find(
        //       step => step.slug === STEP_SLUGS.INFUSION
        //   );
        //   return {
        //       disabledAllItem : outboundInitialValues?.status >= 1 || !infusionDateFilledStatus?.infusion_date,
        //   };
        //   }, [allInitialSteps,outboundInitialValues]);
  
        //   console.log('disabledAllItem',disabledAllItem)
        //   const [finalInitialization] = useState(outboundInitialValues);
  
        //  useEffect(() => {
        //   if(currentCycle?.outbound_form_id){
        //       getOutbondFormDetails()
        //   }else{
        //    setOutboundInitialValues(prev => ({ ...prev, ...finalInitialization, status: 0  }));
        //   }
        // }, [getOutbondFormDetails, currentCycle]);

       useEffect(() => {
           if(currentCycle?.outbound_form_id){
               getOutbondFormDetails()
           }
       }, [getOutbondFormDetails, currentCycle]);
  
      // Load data on mount and when patientData.id changes


      useEffect(() => {
      getOutboundFilledData()
      }, [getOutboundFilledData,currentCycle,patientData]);

// const values = outboundInitialValues;


useEffect(() => {
  if (
    !fieldSet?.length ||
    !Object.keys(outboundInitialValues || {}).length
  ) return;

  setAllPrintData({
    fields: fieldSet,
    values: outboundInitialValues,
    printPatientInfo:patientData,
    title: "Out-Bound Form",
  });
}, [fieldSet, outboundInitialValues, patientData]);
// console.log('outboundInitialValues', outboundInitialValues)
  return (
    <>
      {currentCycle?.coa_forms_id  
    //   && !patientData.id && !currentCycle?.product_manufacturing_id && !currentCycle?.feasibility_assessments_id ?
        ?(
          <>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <LoadingButton
                type="button"
                size="small"
                onClick={handleFullPrint}
                className="!w-[100px] "
              >
                Print
              </LoadingButton>
            </Box>
            {allPrintData ? (<>
              {isLoading ? <SkeletonLoader
                rowCount={2}
                height={130}
                // width={140}p
                isTable={false}
              /> : <div>
                <QrAllPrintContent
                  ref={printContentAllRef}
                  printData={allPrintData}
                   type={"outbound"}
                />
              </div>}

            </>
            ): <NoDataCard heading="No Data to Display" />
        }
          </>
        ) : (
          <div >
            <NoDataCard heading="No Data to Display" />
          </div>
        )
      }
    </>
  );

}

export default DownlaodOutboundForm